module.exports = __webpack_public_path__ + "static/img/充值_1.316918bd.png";